export const useTogglePopup = (id) => {
  document.querySelector(`.popup__wrapper#${id}`).classList.toggle('popup__wrapper--active')
}